import Vue from 'vue';

export default Vue.component('edit-text-general', {
  template: require('./template.html'),
  name: 'edit-text-general',
  props: ['droplet', 'show-edit-bubble'],
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/text-general/components/_edit-options/index.js